import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappApiIntegration = () => (
  <>
    <Helmet>
      <title>WhatsApp API Integration for Business Apps | HAWKTRION</title>
      <meta name="description" content="Connect WhatsApp messaging with your CRM, website, ecommerce platform, or custom application using HAWKTRION APIs and webhooks." />
      <meta name="keywords" content="WhatsApp API integration, integrate WhatsApp with CRM, WhatsApp business app integration" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-api-integration/" />
      <meta property="og:title" content="WhatsApp API Integration for Business Apps | HAWKTRION" />
      <meta property="og:description" content="Connect WhatsApp messaging with your CRM, website, ecommerce platform, or custom application using HAWKTRION APIs and webhooks." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-api-integration/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp API Integration for Business Apps | HAWKTRION" />
      <meta name="twitter:description" content="Connect WhatsApp messaging with your CRM, website, ecommerce platform, or custom application using HAWKTRION APIs and webhooks." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="Integrate WhatsApp API With Your Business Apps" hideCta>
      <RemainingLandingContent pageKey="integration" />
    </SeoLandingPage>
  </>
);

export default WhatsappApiIntegration;